import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Dropdown } from "semantic-ui-react";
import "./StandardDialogBox.scss";
import axios from "axios";
import { connect } from "react-redux";
import translator from "../../utils/translator";

function StandardDialogBox(props) {
	const [open, setOpen] = React.useState(false);
	const [products, setProducts] = React.useState([]);
	const [standards, setStandards] = React.useState([]);
	const [standard_ref, setStandardRef] = React.useState({});
	const [saving, setSaving] = React.useState({ status: 0 });

	async function handleClickOpen() {

		let response = await axios.post(props.APIUrl + "/standards/get-standards", {
			projectId: props.projectId
		});

		let standard_ref = response.data.standards.reduce((obj, standard) => ({ ...obj, [standard.product_sku]: standard }), {});
		setStandardRef(standard_ref);

		let responseStandards = response.data.standards.map(standard => ({
			value: standard.product_sku,
			text: "(" + standard.product_sku + ") " + standard.title + " $" + standard.amount
		}));

		let responseProducts = response.data.products.map(product => {
			product.total = 0;
			product.errors = [];

			if(!!product.allowances) {
				product.allowances = product.allowances.reduce((allowances, allowance) => {
					if(!standard_ref[allowance.standard_sku]) {
						product.errors.push({
							sku: allowance.standard_sku,
							title: "(" + allowance.standard_sku + ") " + allowance.standard_title + " $" + allowance.amount,
							message: "standard_missing"
						});
					}
					else if(standard_ref[allowance.standard_sku].amount != allowance.amount) {
						product.errors.push({
							sku: allowance.standard_sku,
							title: "(" + allowance.standard_sku + ") " + allowance.standard_title + " $" + allowance.amount,
							message: "standard_wrong_price"
						});
					}
					else {
						allowances.push(allowance.standard_sku);
					}
					product.total += parseFloat(allowance.amount);
					return allowances;
				}, []);
			}
			return product;
		});

		setStandards(responseStandards);
		setProducts(responseProducts);
		setSaving({ status: 0 });
		setOpen(true);
	}

	function handleClose() {
		setOpen(false);
	}

	async function saveStandard() {
		let data = {
			projectId: props.projectId,
			product_id: saving.product,
			allowances: saving.allowances.map(sku => standard_ref[sku].id)
		};
		let response = await axios.post(props.APIUrl + "/standards/save-standards", data);
		setSaving({ ...saving, status: 2 });
	}

	useEffect(() => {
		if (saving.status === 1) saveStandard();
	}, [saving]);

	return (
		<div class="">
			<Button variant="outlined" color="primary" onClick={handleClickOpen}>
				<i class="fa fa-exchange-alt" />
				{translator("Project Shopping", "standards")}
			</Button>
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					{translator("Project Shopping", "standards")}
					<Button id="set-price-close-button" onClick={handleClose} color="primary">
						<i class="fa fa-window-close fa-2x" aria-hidden="true" />
					</Button>
				</DialogTitle>
				<DialogContent>
					<div className="standard-dialog-box">
						{products.map(product => {
							return (
								<div className="standard-row">
									<div className="standard-title">{product.title}</div>
									<div className="standard-wrapper">
										{!!product.is_standard 
											? (
												<>
													<div>
														<div style={{fontWeight: "bold"}}>{translator("Product Shopping", "item_set_standard")}</div>
														<div>{translator("Product Shopping", "item_set_standard_error")}</div>
													</div>
													<div></div>
												</>
											)
											: (
												<>
													<div>
														<div>{translator("Product Shopping", "item_not_set_standard")}</div>
														<div style={{fontWeight: "bold"}}>{translator("Standards", "allowance_total")}: ${product.total}</div>
													</div>
													{!!Object.keys(product.errors).length
														? (
															<div>
																<div style={{fontWeight: "bold"}}>{translator("Standards", "standard_has_error")}</div>
																<ul>
																	{product.errors.map(error => (
																		<li>
																			<div>{error.title}</div>
																			<div style={{fontWeight: "bold"}}>{translator("Standards", error.message)}</div>
																		</li>
																	))}
																</ul>
																<Button 
																	variant="outlined" 
																	color="primary"
																	onClick={() => {
																		setProducts(
																			products.map(p => (p.id === product.id
																				? {
																					...p,
																					total: product.allowances.reduce((sum, sku) => sum + parseFloat(standard_ref[sku].amount), 0),
																					errors: []
																				}
																				: p
																			))
																		);
																		setSaving({
																			product: product.id,
																			allowances: product.allowances,
																			status: 1
																		});
																	}}
																>
																	{translator("Standards", "remove_allowances")}
																</Button>
															</div>
														)
														: (
															<div className="standard-dropdown-wrapper">
																<Dropdown 
																	fluid
																	multiple
																	selection
																	placeholder={translator("Product Shopping", "available_standards")}
																	options={standards}
																	value={product.allowances}
																	onChange={(e, {value}) => {
																		setProducts(
																			products.map(p => (p.id === product.id
																				? {
																					...p,
																					allowances: value,
																					total: value.reduce((sum, sku) => sum + parseFloat(standard_ref[sku].amount), 0)
																				}
																				: p
																			))
																		);
																		setSaving({
																			product: product.id,
																			allowances: value,
																			status: 1
																		});
																	}}
																/>
																{saving.product === product.id && saving.status === 1 
																	? (<i class="fa fa-spinner fa-spin"></i>) 
																	: ""
																}
																{saving.product === product.id && saving.status === 2 
																	? (<i class="standard-success fas fa-check-circle"></i>) 
																	: ""
																}
															</div>
														)
													}
												</>
											)
										}
									</div>
								</div>
							);
						})}
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StandardDialogBox);
